<template>
<div class="card bg-white">
    <div class="card-header bg-primary text-white">
        <h5 class="card-title">Attendance</h5>
    </div>
    <div class="card-body position-relative">
        <div class="row">
            <div class="col-5">
                <div class="row" v-if="shift[currentDate]">
                    <div class="col-md-4">
                        <strong class="h6">Shift Duration:</strong>
                    </div>
                    <div class="col-md-8">
                        <span> {{ start_time }} <strong> to </strong> {{ end_time }} </span>
                    </div>
                </div>
                <br />
                <div class="row" v-if="punch_in_time">
                    <div class="col-md-4">
                        <strong class="h6">Punch In Time:</strong>
                    </div>
                    <div class="col-md-8">
                        <span class="font-weight-bold">
                            {{ punch_in_time }}
                        </span>
                    </div>
                </div>
                <br v-if="punch_in_time" />
                <div class="row" v-if="punch_in_note">
                    <div class="col-md-4">
                        <strong class="h6">Note:</strong>
                    </div>
                    <div class="col-md-8">
                        <span class="font-weight-bold">
                            {{ punch_in_note }}
                        </span>
                    </div>
                </div>
                <br v-if="punch_in_note" />
              

                <div class="row">
                    <div class="col-md-4">
                        <strong class="h6">Date: </strong>
                    </div>
                    <div class="col-md-8">
                        {{ currentDate }}
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-md-4"><strong class="h6">Time: </strong></div>
                    <div class="col-md-8">
                        {{ currentTime }}
                    </div>
                </div>
                <br>
                <div v-if="shift[currentDate]">
                    <div class="punchin" v-if="shouldDisplayPunchInButton">
                        <label for="punch_in_note" class="h5 mb-2">Note:</label>
                        <textarea v-model="punch_in_note" type="text" id="punch_in_note" class="form-control mb-2 mt-2" autocomplete="off"></textarea><br />
                        <button @click="actionPuched" class="btn mt-2" :class="{ 'btn-success': puchBtnStatus == 0 }">
                            {{ punchInButtonText }}
                        </button>
                    </div>
                    <div v-else>
                        <div class="punchout">
                            <label for="punch_out_note" class="h5">Note:</label>
                            <textarea v-model="punch_out_note" type="text" id="punch_out_note" class="form-control mb-2" autocomplete="off" placeholder="Enter a note..."></textarea><br />
                            <button v-if="puchBtnStatus == 1" @click="actionPuched" class="btn mt-2" :class="{ 'btn-danger': puchBtnStatus == 1 }">
                                Punch Out
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
                </div>
                <div class="col">
                    <p v-if="!loadingSpin && isShiftTimeEnded && puchBtnStatus === 0" class="font-weight-bold text-danger ml-60">
                        {{ this.timeEnds }}
                    </p>
                </div>

                <div class="col">
                    <p v-if="!loadingSpin && shift.length === 0 " class="font-weight-bold text-danger ml-60">
                        Shift not Added
                    </p>
                </div>

            </div>
            <div class="col-7">
                <h2 v-if="attendanceLogs.length > 0" class="heading-logs">Attendance Logs</h2>
                <div class="puchin_card" v-if="shift[currentDate] && shift[currentDate].length > 0">
                    <div class="row ">
                        <div class="card col-5 Emp_card" v-for="(log, index) in attendanceLogs" :key="index">
                            <div class="row">
                                <div class="col-8">
                                    <span class="Emp_name">{{ shiftdata.employee.name }}</span>
                                </div>
                                <div class="col-4">
                                    <i class="fa fa-clock-o" style="color:#00779C;"></i>
                                    <span>{{ formatTime(log.punch_in_time) }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-8">
                                    <span class="Job_name">{{ shiftdata.jobRole.name }}</span>
                                </div>
                                <div class="col-4">
                                    <i class="fa fa-clock-o" style="color:#963526;"></i>
                                    <span>{{ formatTime(log.punch_out_time)}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import moment from "moment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
    name: "employeeShifts",

    components: {
        ClipLoader,
    },
    data() {
        return {
            size: "25px",
            spinnerColor: "#00779C",
            shift: [],
            shiftdata: null,
            punch_in_note: null,
            punchedIn: false,
            loadingSpin: true,
            punch_in_time: "",
            punch_out_note: "",
            lastAttendance: null,
            start_time: null,
            end_time: null,
            currentDate: moment().format("YYYY-MM-DD"),
            currentTime: moment().format("hh:mm A"),
            puchBtnStatus: -1,
            shiftIndex: 0,
            attenceId: 0,
            currentShift: [],
            timeEnds: "Your Shift Time Ends",
            attendanceLogs: []

        };
    },
    computed: {
        shouldDisplayPunchInButton() {
            return this.puchBtnStatus === 0 && !this.isShiftTimeEnded;
        },

        isShiftTimeEnded() {
            const endTimeMoment = moment(this.end_time, "hh:mm A");
            const currentTimeMoment = moment(this.currentTime, "hh:mm A");
            return currentTimeMoment.isAfter(endTimeMoment);
        },

        punchInButtonText() {
            return this.isShiftTimeEnded ? this.timeEnds : "Punch In";
        }
    },

    mounted() {
        this.getEmployeeShifts();
        this.updateCurrentTime();
    },

    methods: {
        updateCurrentTime() {
            setInterval(() => {
                this.currentTime = moment().format("hh:mm A");
            }, 1000);
        },
        formatTime(dateTime) {
    if (moment(dateTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
        return moment(dateTime).format('h:mm:ss A'); 
    } else {
        return ''; 
    }
},
        actionPuched() {
            const attendances = [{
                punch_in_note: this.punch_in_note,
                punch_out_note: this.punch_out_note,
            }, ];
            let punch_in_device_type = this.puchBtnStatus === 0 ? "web" : "";
            let punch_out_device_type = this.puchBtnStatus === 1 ? "web" : "";
            const data = {
                shiftId: this.shift[this.currentDate][this.shiftIndex]["id"],
                id: this.attenceId,
                attendances: attendances,
                callFlag: this.puchBtnStatus,
            };

            this.$axios({
                    method: "post",
                    url: this.$punchedShiftTime,
                    data: {
                        shift: data,
                        punch_in_device_type: punch_in_device_type,
                        punch_out_device_type: punch_out_device_type
                    },
                    headers: this.getAuthHeader(),
                })
                .then((res) => {
                    if (res.data.status === 200) {
                        this.attenceId = res.data.result.id;
                        this.puchBtnStatus = this.puchBtnStatus ? 0 : 1;
                        if (this.puchBtnStatus) {
                            this.punch_in_time = res.data.result.punch_in_time;
                        } else {
                            this.punch_in_time = "";
                            this.punch_in_note = "";
                        }
                    } else {
                    }
                    this.getAttendanceLogs();
                })
                .catch((error) => {
                    console.error("Error during punch in API call:", error);
                });
        },
        getAttendanceLogs() {
            this.$axios({
                method: "get",
                params: {
                    schedule_id: this.shiftdata.id,
                    employee_id: this.shiftdata.employee_id,
                },
                url: this.$attendanceLogs,
                headers: this.getAuthHeader(),
            }).then((res) => {
                if (res.data && res.data.status === 200) {
                    this.attendanceLogs = res.data.result;
                } else {
                    console.error("Failed to fetch attendance logs:", res.data.message);
                }
            }).catch((error) => {
                console.error("Error fetching attendance logs:", error);
            });
        },

        getEmployeeShifts() {
            this.loadingSpin = true;
            this.$axios({
                method: "get",
                params: {
                    company_id: this.$store.getters.getSelectedCompany.id,
                    user_id: this.$store.getters.getUser.id,
                },
                url: this.$GetShift,
                headers: this.getAuthHeader(),
            }).then((res) => {
                if (res.data.status == 200) {
                    if (
                        res.data.result &&
                        res.data.result.upComingShifts &&
                        res.data.result.upComingShifts[this.currentDate]
                    ) {
                        this.shift = res.data.result.upComingShifts;
                        let currentShiftIndex = Object.keys(this.shift[this.currentDate]);
                        if (currentShiftIndex.length) {
                            this.shiftIndex = currentShiftIndex[0];
                            this.currentShift =
                                this.shift[this.currentDate][this.shiftIndex[0]];
                            if (this.currentShift && this.currentShift.attendance) {
                                let lastAtt = this.currentShift.attendance;
                                this.attenceId = lastAtt.id;
                                if (lastAtt.punch_out_time != null) {
                                    this.puchBtnStatus = 0;
                                } else {
                                    this.puchBtnStatus = 1;
                                    this.punch_in_time = lastAtt.punch_in_time;
                                    this.punch_in_note = lastAtt.punch_in_note;
                                }
                            } else {
                                this.puchBtnStatus = 0;
                            }
                        }

                        this.start_time =
                            this.shift[this.currentDate][this.shiftIndex].start_time;
                        this.end_time =
                            this.shift[this.currentDate][this.shiftIndex].end_time;
                        this.shiftdata = this.shift[this.currentDate][this.shiftIndex];
                    }
                    this.loadingSpin = false;
                    this.getAttendanceLogs();
                }
            });
        },
        savePunchedInState() {
            localStorage.setItem("punchedIn", this.punchedIn.toString());
        },
        loadPunchedInState() {
            const punchedInState = localStorage.getItem("punchedIn");
            this.punchedIn = punchedInState === "true";
        },
    },
};
</script>

<style>
.pointerEvent {
    cursor: pointer;
}

.date-picker-width {
    width: 100% !important;
}

.picker-input {
    border: 0 !important;
    background: #f6f6f6 !important;
    box-shadow: none !important;
    height: 40px !important;
}

.shiftTimeCol {
    color: #ccc !important;
}

.inputs-wrapper .row {
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 20px !important;
}

.inputs-wrapper .row .form-control {
    color: #242424;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}

.inputs-wrapper .row .col-3 {
    padding: 2px !important;
}

.text-red {
    color: red;
}

.small-btn {
    padding: 5px 10px;
    font-size: 12px;
}

#punch_in_note,
#punch_out_note {
    width: 400px;
}

.puchin_card .card {
    padding: 5px 5px;
}

.Emp_card {
    margin-right: 10px !important;
    padding: 12px !important;
    border-color: #7c6f6f !important;
    margin: 10px !important;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.Emp_name {
    font-size: 16px;
    line-height: 20px;
    /* font-weight: 400; */
    color: #242424;
}

.Job_name {
    font-size: 11px;
}

.heading-logs {
    background-color: #fdfdfd;
    width: 770px;
}
</style>
